import {AsyncStateStatus, IPaginator} from '../root.types'

export enum AddressTypes {
    ADDRESS_PERSON_REQUEST = '@address/addressPersonRequest',
    ADDRESS_COMPANY_REQUEST = '@address/addressCompanyRequest',
    ADDRESS_PERSON_GEOMETRY_REQUEST = '@address/addressPersonGeometryRequest',
    ADDRESS_COMPANY_GEOMETRY_REQUEST = '@address/addressCompanyGeometryRequest',
    ADDRESS_CANCEL = '@address/addressCancel',
}

export interface IActionAddressRequest {
    readonly filters: IFiltersAddress
    readonly paginator?: IPaginator
}

export interface IFiltersAddress {
    readonly zipCode?: string
    readonly state?: string
    readonly city?: string
    readonly number?: number
    readonly street?: string
    readonly polygon?: any
    readonly nInfo?: number
    readonly district?: string
    readonly start_date?: string
    readonly end_date?: string
    readonly radius?: number
    readonly latitude?: number
    readonly latitudes?: number[]
    readonly longitude?: number
    readonly longitudes?: number[]
}

export interface IAddressState {
    readonly status: AsyncStateStatus
    readonly data: Array<any>
}

export interface IAddressDescribeState {
    readonly status: AsyncStateStatus
    readonly data: any
}

export interface AddressState {
    person: IAddressState
    company: IAddressState
    geometryPerson: IAddressState
    geometryCompany: IAddressState
}
